import { render, staticRenderFns } from "./PaperSync.vue?vue&type=template&id=c1157ede&scoped=true&"
import script from "./PaperSync.vue?vue&type=script&lang=js&"
export * from "./PaperSync.vue?vue&type=script&lang=js&"
import style0 from "./PaperSync.vue?vue&type=style&index=0&id=c1157ede&scoped=true&lang=css&"
import style1 from "@/assets/wap/cloud-mobile.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1157ede",
  null
  
)

export default component.exports